import { ActivityData } from '@ysura/common';

export const checkIfPromatExists = (activity: ActivityData | null) => {
  if (!activity) return false;

  return activity?.attendees?.length === 1;
};
